import HelpIcon from '@mui/icons-material/Help';
import MapIcon from '@mui/icons-material/Map';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled } from '@mui/material/styles';
import React, { useContext } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { establishOrRefreshSession } from '../../common/sessionGate';
import { getAppIcon } from '../../common/dynamicCustomizationService';
import { GlobalContext } from '../../services/context/DataContext';
import { useNotification } from '../../services/customHooks/useNotification';
import { IButton, ILink, ITooltip } from '../1elements/';
import DefaultLogo from '../1elements/Icons/png/proximityLogo.png';
import AppsMenuGoogle from '../3modules/AppsMenuGoogle';
import AppsMenuMicrosoft from '../3modules/AppsMenuMicrosoft';
import UserMenu from '../3modules/UserMenu';

const CustomLogo = getAppIcon();

const SidebarRoot = styled('div')({
  width: 60,
  height: '100%',
  paddingTop: 32,
  paddingBottom: 58,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  position: 'fixed',
  zIndex: 10,
  backgroundColor: '#f8f8fa',
  boxShadow: '0 0 3px #00000029'
});

const SidebarSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center'
});

const SidebarActions = styled(SidebarSection)({
  gap: 24
});

const SidebarApps = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 10
});

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const { sidePanelState } = useContext(GlobalContext);
  const [showSidePanel] = sidePanelState;

  const isMatch = useMediaQuery('(max-width:750px)');

  const handleClick = () => {
    establishOrRefreshSession();
  };

  const identityProviderName =
    window.localStorage.getItem('identityProvider') || 'guest';

  useNotification();

  const renderProviderApps = (providerName) => {
    const apps = {
      google: () => <AppsMenuGoogle />,
      microsoft: () => <AppsMenuMicrosoft />
    };

    const appsToRender = apps[providerName];

    return appsToRender ? appsToRender() : null;
  };

  if (!showSidePanel || isMatch) {
    return null;
  }

  return (
    <SidebarRoot className="sidebar">
      <SidebarSection>
        <ILink onClick={() => navigate('/faq')}>
          <img src={CustomLogo || DefaultLogo} alt="" width={35} />
        </ILink>
      </SidebarSection>

      <SidebarActions>
        <SidebarApps>
          <ITooltip content="Search" placement="right" arrow>
            <NavLink
              to="/home"
              end
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              <IButton
                isSidebar={false}
                opened={location.pathname === '/home'}
                isMenu
                handleClick={handleClick}
              >
                <MapIcon />
              </IButton>
            </NavLink>
          </ITooltip>

          {renderProviderApps(identityProviderName)}

          <ITooltip content="FAQ" placement="right" arrow>
            <NavLink
              to="/faq"
              end
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              <IButton
                isSidebar={false}
                opened={location.pathname === '/faq'}
                isMenu
                handleClick={handleClick}
              >
                <HelpIcon />
              </IButton>
            </NavLink>
          </ITooltip>
        </SidebarApps>

        <UserMenu />
      </SidebarActions>
    </SidebarRoot>
  );
}
